import React from 'react';
import styled from 'styled-components';
import { camelCaseToWords } from '../docOvelayTool';

const StaticField = ({ label, value, wide = false }) => {
  return (
    <Wrapper>
      <Label wide={wide}>{camelCaseToWords(label)}</Label>
      <Value>{value || '—'}</Value>
    </Wrapper>
  );
};

export default StaticField;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif;
  min-width: 0;
`;

export const Label = styled.div<{ wide: boolean }>`
  font-size: 0.625rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--neutral-500);
  min-width: ${({ wide }) => (wide ? '120px' : '0')};
  line-height: 1.3;
`;

const Value = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--mainText);
  line-height: 1.35;
  word-break: break-word;
`;
